import React, { useState } from "react";
import MiniHeroSection from "../components/MiniHeroSection";
import ContentBelowHeroBanner from "../components/ContentBelowHeroBanner";
import OpenRolesSection from "../components/OpenRolesSection";
import WhyJoinSky47Section from "../components/WhyJoinSky47Section";
import ThereIsMoreSection from "../components/ThereIsMoreSection";
import useSWR from "swr";
import { Helmet } from "react-helmet-async";
import { secureFetcher, SECURITY_CONFIG } from "../config/security";

function Careers() {
  const {
    data: CareersData,
    error,
    isLoading,
  } = useSWR(
    `${SECURITY_CONFIG.API_BASE_URL}${SECURITY_CONFIG.WP_PAGES_ENDPOINT}/183`,
    secureFetcher
  );
  const {
    data: jobPosts,
    error: jobPostsErrors,
    isLoading: jobPostsIsLoadings,
  } = useSWR("https://47.activ8.digital/wp-json/wp/v2/jobs", secureFetcher);

  return (
    <>
      {CareersData && (
        <Helmet>
          <title>{CareersData.yoast_head_json?.title}</title>
          <meta
            property="og:title"
            content={CareersData.yoast_head_json?.og_title}
          />
          <meta
            property="og:description"
            content={CareersData.yoast_head_json?.og_description}
          />
        </Helmet>
      )}
      <MiniHeroSection data={CareersData?.acf?.hero_banner} />
      <ContentBelowHeroBanner
        data={CareersData?.acf?.content_below_hero_banner}
      />
      <OpenRolesSection
        data={jobPosts}
        careers={CareersData?.acf?.open_roles_section}
      />
      <WhyJoinSky47Section data={CareersData?.acf?.why_join_sky47_section} />
      <ThereIsMoreSection data={CareersData?.acf?.theres_more_section} />
    </>
  );
}

export default Careers;
